import { defineMessages } from '../i18n/messages';
import { englishText } from '../utils/messageFallbacks';

/*
 * Header's own strings. The nav link labels live in NavigationComponent.messages and the
 * brand name in Common.messages; what is here is the two icon-only controls in the bar,
 * which have no visible text and so exist only as accessible names.
 */
const HEADER_DEFINITIONS = {
  MOBILE_TOGGLE_ARIA: {
    id: 'header.mobile_toggle_aria',
    text: 'Menu',
    description:
      'Accessible name of the hamburger button that opens the navigation on narrow screens. The button shows only an icon, so this is the whole of what a screen reader announces. Name the thing it opens, not the act of opening it — the button also reports its own expanded state.',
  },
  THEME_TOGGLE_ARIA: {
    id: 'header.theme_toggle_aria',
    text: 'Dark mode',
    description:
      'Accessible name of the icon-only button in the header that switches between the light and dark colour themes. It is announced together with a pressed/unpressed state, so this names the setting ("Dark mode") rather than an action ("Switch to dark mode").',
  },
};

export const HeaderMessages = defineMessages(HEADER_DEFINITIONS);

/** English fallbacks, used until `npm run lx:extract` adds these ids to en-US.json. */
export const HeaderText = englishText(HEADER_DEFINITIONS);
